@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.modal-body {
  padding: 30px;
}

.delete {
  width: 100%;
  margin-top: 15px;
  padding: 10px 0 10px 15px;
  border-left: solid 5px @settings-page--automation-rules-modal-delete--border-color;
}
